<template>
  <br>
  <div>
    <button class="light-button" @click="clickHandler">Trainers</button>
    <ListView :items="itemList" :height="160" @item-clicked="handleItemClicked" />
  </div>
</template>

<script setup>

import { onMounted, ref, inject } from 'vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import ListView from '@/components/utils/ListView.vue';

import { useRouter } from 'vue-router';

const emit = defineEmits(['card_updated']);
const props = defineProps({ projectID: Number });
const isPublic = inject('isPublic', false);
const itemList = ref([]);
const router = useRouter();

function clickHandler() {
  router.push({ name: `${isPublic ? 'public.' : ''}experiment`, params: { projectId: props.projectID } });
}

onMounted(async () => {
  getDatasets();
});

async function getDatasets() {
  const dataConnect = new DatastoreConnect();
  const result = await dataConnect.getExperimentList({ project_id: props.projectID })
    .then(async (data) => {
      if (!data.result) {

      } else {
        const exp = data.result;
        itemList.value = [];

        for (let k = 0; k < exp.length; k++) {
          const item = {};
          item.url = `/${props.projectID}/experiment/list`;
          item.id = `exp-${exp[k].id.toString(16)}`;
          item.exp_id = exp[k].id;
          item.name = exp[k].name;
          item.date = exp[k].date;
          item.description = exp[k].description;
          itemList.value.push(item);
        }
      }
    })
    .catch((error) => {

    });
}

function handleItemClicked(item) {
  router.push({
    name: `${isPublic ? 'public.' : ''}experiment.training.list`,
    params: {
      projectId: props.projectID,
    },
    query: {
      exp_id: item.exp_id,
    },
  });
}

</script>

<style lang="scss" scoped>

</style>
